import { render, staticRenderFns } from "./create-role-dialog.vue?vue&type=template&id=57ce03a2&"
import script from "./create-role-dialog.vue?vue&type=script&lang=js&"
export * from "./create-role-dialog.vue?vue&type=script&lang=js&"
import style0 from "./create-role-dialog.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ce03a2')) {
      api.createRecord('57ce03a2', component.options)
    } else {
      api.reload('57ce03a2', component.options)
    }
    module.hot.accept("./create-role-dialog.vue?vue&type=template&id=57ce03a2&", function () {
      api.rerender('57ce03a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/roles/components/create-role-dialog.vue"
export default component.exports